import { SecureStorage } from "@aparajita/capacitor-secure-storage";
import { Capacitor } from "@capacitor/core";

const refreshCredentialKey = "refresh-credential";
let storageInitialization: Promise<void> | null = null;

export function isNativeApp(): boolean {
  return Capacitor.isNativePlatform();
}

async function initializeStorage(): Promise<void> {
  if (!isNativeApp()) {
    throw new Error("Secure credential storage is only available in the native app");
  }
  if (!storageInitialization) {
    storageInitialization = SecureStorage.setKeyPrefix("celsus-auth_");
  }
  await storageInitialization;
}

export async function getMobileRefreshCredential(): Promise<string | null> {
  await initializeStorage();
  return SecureStorage.getItem(refreshCredentialKey);
}

export async function setMobileRefreshCredential(value: string): Promise<void> {
  await initializeStorage();
  await SecureStorage.setItem(refreshCredentialKey, value);
}

export async function clearMobileRefreshCredential(): Promise<void> {
  await initializeStorage();
  await SecureStorage.removeItem(refreshCredentialKey);
}
